const flatten = (arr) => (
  arr.reduce((flat, toFlatten) => (
    flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten)
  ), [])
);

const zeroFill = (number, width) => {
  // eslint-disable-next-line no-param-reassign
  width -= number.toString().length;
  if (width > 0) {
    return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
  }
  return `${number}`;
};


const formatNumber = (number) => {
  if (Number.isNaN(number)) {
    return number;
  }
  let val = (1.0 * number).toFixed(0);
  if (val === 0) return '0';
  const f = [];
  f[0] = parseInt(val % 1000, 10);
  val /= 1000;
  f[1] = parseInt(val % 1000, 10);
  val /= 1000;
  f[2] = parseInt(val % 1000, 10);
  val /= 1000;
  f[3] = parseInt(val % 1000, 10);
  val /= 1000;

  let ret = '';
  // eslint-disable-next-line no-nested-ternary
  ret += ret === '' ? (f[3] === 0 ? '' : `${f[3]}'`) : `${zeroFill(f[3], 3)}'`;
  // eslint-disable-next-line no-nested-ternary
  ret += ret === '' ? (f[2] === 0 ? '' : `${f[2]}'`) : `${zeroFill(f[2], 3)}.`;
  // eslint-disable-next-line no-nested-ternary
  ret += ret === '' ? (f[1] === 0 ? '' : `${f[1]}.`) : `${zeroFill(f[1], 3)}.`;
  // eslint-disable-next-line no-nested-ternary
  ret += ret === '' ? (f[0] === 0 ? '' : f[0]) : zeroFill(f[0], 3);
  return ret;
};

export { flatten, formatNumber };
